import React from 'react'
import { CheckoutSection, formatMoney } from '../../components'
import { translateResourceString } from '../../../util/translationUtility';
import styles from './checkout.module.css';

const spinnerSpan = <span className="fa fa-spinner fa-spin" />;

const CheckoutSummary = (
  {
    summary: {
      ShippingMethod,
      ShippingTotal,
      SubTotal,
      Total,
      Currency,
      TaxTotal,
      DiscountTotal
    },
    isRefreshing
  }) => {
  const formatCurrency = formatMoney(Currency);
  return (
    <CheckoutSection label='Summary' hidden={false}>
            <div className="checkout-summary-wrapper bg-grey-light p-2">
              <div className="collapse-xs">
                  <div className="collapse show" id="cartSummary">
                      <div className="summary-subtotal d-flex justify-content-between bb-1-blue-20 pb-2">
                          <label className="subtotal">{translateResourceString("/Checkout/Summary/SubtotalLabel")}</label>
                          <span className="subtotal currency-amt">{formatCurrency(SubTotal)}</span>
                      </div>
                      {ShippingTotal != null &&
                          <div className="summary-total d-flex justify-content-between bb-1-blue-20 py-2">
                              <label className="shipping">{translateResourceString("/Checkout/Summary/ShippingLabel")}</label>
                              <span className="shipping currency-amt"> {ShippingTotal === 0 ? "Free" : formatCurrency(ShippingTotal || 0)}</span>
                         </div>
                      }
                      {TaxTotal != null &&
                          <div className="summary-tax d-flex justify-content-between bb-1-blue-20 py-2">
                              <label className="tax">{translateResourceString("/Checkout/Summary/TaxLabel")}</label>
                              <span className="tax currency-amt">{formatCurrency(TaxTotal)}</span>
                          </div>}
                      {DiscountTotal != null && DiscountTotal > 0 &&
                          <div className="summary-tax d-flex justify-content-between bb-1-blue-20 py-2">
                              <label className="tax">{translateResourceString("/Checkout/Summary/DiscountLabel")}</label>
                              <span className="tax currency-amt">{formatCurrency(-DiscountTotal)}</span>
                          </div>}
                      <div className="summary-total d-flex justify-content-between fw-600 pt-2">
                          <label className="total">{translateResourceString("/Checkout/Summary/TotalLabel")}</label>
                          <span className="shipping currency-amt">{formatCurrency(Total)}</span>
                      </div>
                  </div>
            </div>
       </div>
    </CheckoutSection>
  );
}

export default CheckoutSummary
